import qs from "qs";
import axios from "axios";
import { API_URL, URL } from "../../../../constants/Constants";

/**
 * Obtiene datos completos de reparaciones
 * @param {string} type - Tipo de pantalla
 * @param {string} typeConnect - Tipo de conexión
 * @param {number} currentScreenId - ID de la pantalla actual
 * @returns {Promise<Array|false>} Datos de reparaciones o false si no se encuentran
 */
export const getFullReparaciones = async (type, typeConnect, currentScreenId) => {
  const queryData = {
    screen: type,
    action: typeConnect,
    query_type: currentScreenId,
    proceso_tipo: "Reparaciones",
  };

  try {
    const response = await axios.post(API_URL, qs.stringify(queryData));

    if (response.data.status === "ok") {
      return response.data.data;
    } else {
      console.log("Pieza no encontrada");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};

/**
 * Obtiene datos completos de reparaciones externas
 * @param {number} queryType - Tipo de consulta
 * @param {string} query_param - Parámetro de consulta
 * @returns {Promise<Array|false>} Datos de reparaciones externas o false si no se encuentran
 */
export const getFullReparacionesExternas = async (queryType, query_param) => {
  const queryData = {
    query_type: queryType,
    query_param: query_param,
  };

  try {
    const response = await axios.post(URL, qs.stringify(queryData));

    if (response.data.status === "ok") {
      return response.data.data;
    } else {
      console.log("Pieza no encontrada");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};

/**
 * Obtiene datos completos de reparaciones internas
 * @param {number} queryType - Tipo de consulta
 * @param {string} query_param - Parámetro de consulta
 * @returns {Promise<Array|false>} Datos de reparaciones internas o false si no se encuentran
 */
export const getFullReparacionesInternas = async (queryType, query_param) => {
  const queryData = {
    query_type: queryType,
    query_param: query_param,
  };

  try {
    const response = await axios.post(URL, qs.stringify(queryData));

    if (response.data.status === "ok") {
      return response.data.data;
    } else {
      console.log("Pieza no encontrada");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};

/**
 * Obtiene datos completos de control de trabajo externo
 * @param {number} queryType - Tipo de consulta
 * @param {string} query_param - Parámetro de consulta
 * @returns {Promise<Array|false>} Datos de control de trabajo externo o false si no se encuentran
 */
export const getFullControlDeTrabajoExterno = async (queryType, query_param) => {
  const queryData = {
    query_type: queryType,
    query_param: query_param,
  };

  try {
    const response = await axios.post(URL, qs.stringify(queryData));
    if (response.data.status === "ok") {
      return response.data.data;
    } else {
      console.log("Pieza no encontrada");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};

/**
 * Obtiene trabajo de reparación completo
 * @param {string} queryType - Tipo de consulta
 * @param {string} query_param - Parámetro de consulta
 * @returns {Promise<Object|false>} Datos de respuesta o false si hay error
 */
export const getFullWorkRepair = async (queryType, query_param) => {
  const queryData = {
    query_type: queryType,
    query_param: query_param,
  };

  try {
    const response = await axios.post(URL, qs.stringify(queryData));
    if (response.data.status === "ok") {
      return response.data.data;
    } else {
      console.log("Pieza no encontrada");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};

/**
 * Obtiene reparaciones guardadas
 * @param {string} queryType - Tipo de consulta
 * @param {string} query_param - Parámetro de consulta
 * @returns {Promise<Object|false>} Datos de respuesta o false si hay error
 */
export const getSavedReparaciones = async (queryType, query_param) => {
  const queryData = {
    query_type: queryType,
    query_param: query_param,
  };

  try {
    const response = await axios.post(URL, qs.stringify(queryData));

    if (response.data.status === "ok") {
      return response.data.data;
    } else {
      console.log("Pieza no encontrada");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};

/**
 * Inserta datos de reparaciones
 * @param {string} queryType - Tipo de consulta
 * @param {string} query_param - Parámetro de consulta
 * @param {string} datos - Datos
 * @returns {Promise<Object|false>} Datos de respuesta o false si hay error
 */
export const insertDatosReparaciones = async (queryType, query_param, datos) => {
  const queryData = {
    query_type: queryType,
    query_param: query_param,
    datos: datos,
  };

  try {
    const response = await axios.post(URL, qs.stringify(queryData));

    if (response.data.status === "ok") {
      return response.data.data;
    } else {
      console.log("Pieza no encontrada");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};

/**
 * Inserta datos de trabajo externo
 * @param {string} queryType - Tipo de consulta
 * @param {string} query_param - Parámetro de consulta
 * @param {string} datos - Datos
 * @returns {Promise<Object|false>} Datos de respuesta o false si hay error
 */
export const insertDatosTrabajoExterno = async (queryType, query_param, datos) => {
  const queryData = {
    query_type: queryType,
    query_param: query_param,
    datos: datos,
  };

  try {
    const response = await axios.post(URL, qs.stringify(queryData));

    if (response.data.status === "ok") {
      return response.data.data;
    } else {
      console.log("Pieza no encontrada");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};

/**
 * Obtiene datos completos de pieza de reparación
 * @param {number} currentScreenId - ID de la pantalla actual
 * @param {string} typeConnect - Tipo de conexión
 * @returns {Promise<Object|false>} Datos de respuesta o false si hay error
 */
export const fullDataRepairPiece = async (currentScreenId, typeConnect) => {
  const queryData = {
    query_type: currentScreenId,
    action: typeConnect,
  };
  try {
    const response = await axios.post(URL, qs.stringify(queryData));
    if (response.data.status === "ok") {
      return response.data.data;
    } else {
      console.log("Pieza no encontrada");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};
